// extracted by mini-css-extract-plugin
export default {"wrap":"header_wrap__nr8fi","logoWrap":"header_logoWrap__ccaFI","logoImg":"header_logoImg__r3lHj","logeText":"header_logeText__xY8Lc","logoTextMove":"header_logoTextMove__TRk4C"};